import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const links = [{
    name: 'Home',
    href: '#'
  }, {
    name: 'Therapy Services',
    href: '#'
  }, {
    name: 'Relationship Animals',
    href: '#assessment'
  }, {
    name: 'About',
    href: '#'
  }, {
    name: 'Forms',
    href: '#'
  }, {
    name: 'Contact',
    href: '#'
  }];
  return <nav className="sticky top-0 z-50 w-full bg-accent-50/90 backdrop-blur-md border-b border-accent-100" data-id="element-131" data-mp="kelm0xx90td">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-132" data-mp="ekfkxbyjg06q">
        <div className="flex justify-between h-20" data-id="element-133" data-mp="9kb3njpt31fg">
          <div className="flex items-center" data-id="element-134" data-mp="9iq7xqrr9cg0">
            <a href="#" className="font-title font-bold text-xl text-stone-900" data-id="element-135" data-mp="1pykuqllfn49z">
              Dr. Scott Conkright
            </a>
          </div>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center space-x-5 lg:space-x-7" data-id="element-136" data-mp="1l1kkdyhjvfd2">
            {links.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-stone-600 hover:text-brand-700 transition-colors" data-id="element-137" data-mp="enkdm92wc1jn">
                {link.name}
              </a>)}
            <a href="#assessment" className="hidden xl:inline-flex items-center px-4 py-2 bg-accent-500 text-white rounded-full text-sm font-semibold hover:bg-accent-600 transition-colors" data-id="element-138" data-mp="ol8bv8zpnr6k">
              Take the Assessment
            </a>
          </div>

          {/* Mobile menu button */}
          <div className="flex items-center md:hidden" data-id="element-139" data-mp="5mw0dglbu57t">
            <button onClick={() => setIsOpen(!isOpen)} className="text-stone-600 hover:text-stone-900 focus:outline-none" data-id="element-140" data-mp="5nnu0lvd5svg">
              {isOpen ? <X className="h-6 w-6" data-id="element-141" data-mp="39ao8iklm2a44" /> : <Menu className="h-6 w-6" data-id="element-142" data-mp="31b042st96swa" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Nav */}
      {isOpen && <div className="md:hidden bg-accent-50 border-b border-accent-100" data-id="element-143" data-mp="2wa3zse4zp4qc">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3" data-id="element-144" data-mp="3azrsiqz3uv2g">
            {links.map(link => <a key={link.name} href={link.href} className="block px-3 py-2 text-base font-medium text-stone-600 hover:text-brand-700 hover:bg-stone-100 rounded-md" data-id="element-145" data-mp="363b55yzqckqf">
                {link.name}
              </a>)}
          </div>
        </div>}
    </nav>;
}